import {RaceClass} from "../data/models/bracket_api/RaceClass";

export default function RaceClassFromInt(raceClasses: number[]): RaceClass[] {
    let classes: RaceClass[] = [];
    for(let raceClass of raceClasses) {
        switch (raceClass) {
            case 1:
                classes.push(RaceClass.TOP_FUEL);
                break;
            case 2:
                classes.push(RaceClass.FUNNY_CAR);
                break;
            case 3:
                classes.push(RaceClass.PRO_STOCK);
                break;
            case 4:
                classes.push(RaceClass.PRO_STOCK_MOTORCYCLE);
                break;
            case 5:
                classes.push(RaceClass.PRO_MOD);
                break;
            case 6:
                classes.push(RaceClass.TOP_FUEL_TOP_MOMENTS);
                break;
            case 7:
                classes.push(RaceClass.FUNNY_CAR_TOP_MOMENTS);
                break;
            case 8:
                classes.push(RaceClass.PRO_STOCK_TOP_MOMENTS);
                break;
            case 9:
                classes.push(RaceClass.PRO_STOCK_MOTORCYCLE_TOP_MOMENTS);
                break;
            case 10:
                classes.push(RaceClass.OVERALL_TOP_MOMENTS);
                break;
            default:
                classes.push(RaceClass.TOP_FUEL);
        }
    }
    return classes;
}